module.exports = __webpack_public_path__ + "static/media/home.238f6015.jpg";